import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'antd';
import { NotificationOutlined } from '@ant-design/icons';
import { useCollection } from 'react-firebase-hooks/firestore';
import moment from 'moment';

import Client from 'containers/app/client';

import './style.css';

const NotificationBadge = ({ role }) => {
  const ref = Client.db
    .collection('booking_request')
    .where('worker', '==', Client.currentUserId());
  const [collection, loading, error] = useCollection(ref);

  if (loading) return null;
  if (error) return null;
  if (role === 'isEmployer') return null;

  const pendingRequests = collection.docs.filter((doc) => {
    const { status, dateStart } = doc.data();
    const expired = moment(dateStart).isBefore(moment());
    return status === 'pending' && !expired;
  });

  const count = pendingRequests.length;
  if (count < 1) return null;

  return (
    <Badge className="notification-badge" count={count} dot>
      <NotificationOutlined />
    </Badge>
  );
};

NotificationBadge.propTypes = {
  role: PropTypes.string,
};

NotificationBadge.defaultProps = {
  role: null,
};

export default NotificationBadge;
